import React, { Suspense } from 'react';

import { useClientRoutesContext } from '../../../config/clientRoutes/hooks';
import { getPublicRoutes } from '../routes';
import Routes from './Routes';
import LoggedOutFallBackPage from './LoggedOutFallBackPage';
import AppRoot from './AppRoot';
import PublicPageSettingsProvider from './PublicPageSettingsProvider';
import { Loading } from 'src/modules/shared/components';

const LoggedOutApp = () => {
  const routes = useClientRoutesContext();

  return (
    <AppRoot>
      <PublicPageSettingsProvider>
        <Suspense fallback={<Loading />}>
          <Routes
            routes={getPublicRoutes(routes)}
            fallBackPage={() => <LoggedOutFallBackPage routes={routes} />}
          />
        </Suspense>
      </PublicPageSettingsProvider>
    </AppRoot>
  );
};

export default LoggedOutApp;
